// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__34FL1","clinicsSelect":"TableHeading_clinicsSelect__3lO8-"};